import React, { useEffect } from "react";
import { Box, Button, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeTagModel } from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
} from "../../../../components/Models/admin-modal-theme";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import {
  createTagRequest,
  editTagRequest,
} from "../../../../modules/admin-modules/tags/Actions";

const AddTag = ({ isAdd, data, setSelectedData }) => {
  const openTag = useSelector((state) => state.model.isOpen24);
  const isLoading = useSelector((state) => state.adminTags.isLoading);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  useEffect(() => {
    if (!isAdd && data?.name) {
      setValue("name", data.name);
    }
  }, [data, isAdd, setValue]);

  const header = (
    <Box>
      <Heading
        fontSize="32px"
        fontWeight="800"
        color="#6A1E1E"
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        {isAdd ? "Add Question Tag" : "Edit Question Tag"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="rgba(74, 15, 31, 0.6)"
        textTransform="uppercase"
        letterSpacing="0.14em"
        fontWeight="700"
      >
        Label questions for filtering and reporting
      </Text>
    </Box>
  );

  const onSubmit = async (values) => {
    const action = () => {
      dispatch(closeTagModel());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      let formData = new FormData();
      formData.append("name", values?.name);
      await dispatch(createTagRequest(formData, action));
    } else {
      let formData = new FormData();
      formData.append("_method", "PUT");
      formData.append("name", values?.name);
      dispatch(
        editTagRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeTagModel());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openTag}
      buttonTitle={null}
      buttonFunc={handleSubmit(onSubmit)}
      size="2xl"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
      hideDefaultFooter
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={6} dir="ltr" w="100%">
          <MainInput
            label="Tag name"
            defaultValues={data?.name}
            error={errors?.name?.message}
            placeholder="e.g. Algebra, Mechanics"
            register={register}
            name="name"
            required
          />
          <Flex justify="flex-end" gap={6} pt={4}>
            <Button
              variant="ghost"
              color="#4A0F1F"
              fontWeight="800"
              _hover={{ textDecoration: "underline" }}
              onClick={closeFunc}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bg="#6A1E1E"
              color="white"
              borderRadius="lg"
              px={8}
              py={6}
              fontWeight="800"
              isLoading={isLoading}
              _hover={{ bg: "#4A0F1F" }}
              boxShadow="0 10px 24px rgba(106, 30, 30, 0.18)"
            >
              Save Changes
            </Button>
          </Flex>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddTag;

